import { render, staticRenderFns } from "./course-purchase-dialog.vue?vue&type=template&id=78b3ebd8"
import script from "./course-purchase-dialog.vue?vue&type=script&lang=js"
export * from "./course-purchase-dialog.vue?vue&type=script&lang=js"
import style0 from "./course-purchase-dialog.vue?vue&type=style&index=0&id=78b3ebd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports